// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function PageUITitle(props) {
  var __className = props.className;
  var icon = props.icon;
  var __centered = props.centered;
  var __huge = props.huge;
  var subtitle = props.subtitle;
  var huge = __huge !== undefined ? __huge : false;
  var centered = __centered !== undefined ? __centered : false;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsxs("div", {
              children: [
                icon !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(IconV5.make, {
                              icon: icon,
                              size: 40
                            }),
                        className: "mr-5 rounded-full border border-gray-800 p-2.5 flex shrink-0 text-gray-800"
                      }) : null,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h2", {
                              className: TailwindMerge.twMerge([
                                    "leading-tight font-light text-gray-800 m-0 [&_b]:font-bold [&_i]:italic",
                                    huge ? "text-[26px] md:text-[36px] lg:text-[42px]" : "text-[22px] md:text-[26px] lg:text-[32px]"
                                  ]),
                              dangerouslySetInnerHTML: {
                                __html: props.title
                              }
                            }),
                        subtitle !== undefined ? JsxRuntime.jsx("h6", {
                                children: Caml_option.valFromOption(subtitle),
                                className: TailwindMerge.twMerge([
                                      "mt-3 font-normal leading-snug text-gray-500 md:max-w-[80%] ",
                                      huge ? "text-base md:text-[22px]" : "text-[13px] md:text-base"
                                    ])
                              }) : null
                      ],
                      className: TailwindMerge.twMerge([
                            "flex flex-col",
                            centered ? "items-center" : ""
                          ])
                    })
              ],
              className: TailwindMerge.twMerge([
                    "flex items-center mb-4 md:mb-6",
                    centered ? "text-center" : "",
                    className
                  ])
            });
}

var make = PageUITitle;

exports.make = make;
/* IconV5 Not a pure module */
